"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Menu = _interopRequireDefault(require("@mui/material/Menu"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _styles = require("@mui/styles");
var _ArrowDropDown = _interopRequireDefault(require("@mui/icons-material/ArrowDropDown"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles2 = require("./styles");
var _AnchorLink = _interopRequireDefault(require("../AnchorLink"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const StyledMenu = _ref => {
  let {
    classes,
    label,
    list
  } = _ref;
  const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
  const handleOpen = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: classes.styledMenu
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: classes.buttonContainer,
    onClick: handleOpen
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: classes.button
  }, label), /*#__PURE__*/_react.default.createElement(_ArrowDropDown.default, null)), /*#__PURE__*/_react.default.createElement(_Menu.default, {
    anchorEl: anchorEl,
    id: "simple-menu",
    open: Boolean(anchorEl),
    onClose: handleClose
  }, list.map(item => /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    key: item.label,
    className: classes.menuItem
  }, /*#__PURE__*/_react.default.createElement(_AnchorLink.default, {
    label: item.label,
    href: item.link,
    newTab: item.newTab
  })))));
};
StyledMenu.propTypes = {
  label: _propTypes.default.string,
  list: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    link: _propTypes.default.string,
    newTab: _propTypes.default.bool
  }))
};
var _default = exports.default = (0, _styles.withStyles)(_styles2.useStyles)(StyledMenu);